import http from '~/http/index';
import constant from '~/const';

export default ({
  state: {
    user: {},
  },

  getters: {
    userSecurity(state) {
      const { nfaList } = state.user;
      const mfaIdsList = [0, 1, 3];
      const findMFA = nfaList.filter((data) => {
        const isActuallyEnabled = new Date(data.dateDisabled) < new Date(data.dateEnabled);
        return isActuallyEnabled && mfaIdsList.includes(data.serviceType);
      });
      return nfaList.map((nfa) => {
        return {
          ...nfa,
          isDisabledRemove: mfaIdsList.includes(nfa.serviceType) && findMFA.length === 1,
        };
      });
    },
  },

  mutations: {
    SET_USER(state, data) {
      state.user = data;
    },
  },

  actions: {
    async loadUser({ commit }, value) {
      await commit('SET_USER', {});
      const responses = await Promise.allSettled([
        http.post('v2/User/GetUser', { userId: value }),
        http.get(`p2p/Admin/profile/${value}/ban/info`),
      ]);
      if (responses[1]?.value?.data?.banUntil) {
        responses[0].value.data.userLockList = [
          ...responses[0].value.data.userLockList,
          {
            adminId: null,
            arbitratorId: null,
            comment: '',
            dateCreated: '',
            subType: null,
            type: constant.users.USER_LOCK_TYPE.P2P_IGNORE_CONFIRMATIONS_BAN,
            until: responses[1].value.data.banUntil,
          },
        ];
      }
      await commit('SET_USER', responses[0].value.data);
    },

    async silentLoadUser({ commit }, value) {
      const responses = await Promise.allSettled([
        http.post('v2/User/GetUser', { userId: value }),
        http.get(`p2p/Admin/profile/${value}/ban/info`),
      ]);
      if (responses[1]?.value?.data?.banUntil) {
        responses[0].value.data.userLockList = [
          ...responses[0].value.data.userLockList,
          {
            adminId: null,
            arbitratorId: null,
            comment: '',
            dateCreated: '',
            subType: null,
            type: constant.users.USER_LOCK_TYPE.P2P_IGNORE_CONFIRMATIONS_BAN,
            until: responses[1].value.data.banUntil,
          },
        ];
      }
      await commit('SET_USER', responses[0].value.data);
    },

    async getUser(__store, userId) {
      const responses = await Promise.allSettled([
        http.post('v2/User/GetUser', { userId }),
        http.get(`p2p/Admin/profile/${userId}/ban/info`),
      ]);
      if (responses[1]?.value?.data?.banUntil) {
        responses[0].value.data.userLockList = [
          ...responses[0].value.data.userLockList,
          {
            adminId: null,
            arbitratorId: null,
            comment: '',
            dateCreated: '',
            subType: null,
            type: constant.users.USER_LOCK_TYPE.P2P_IGNORE_CONFIRMATIONS_BAN,
            until: responses[1].value.data.banUntil,
          },
        ];
      }
      return responses[0].value.data;
    },

    async getUsername(__store, userId) {
      const response = await http.post('v2/User/GetUser', { userId });
      return response.data;
    },

    async changeUserPassword(__store, data) {
      const response = await http.post('User/ChangeUserPassword', data);
      return response.data;
    },
  },

  namespaced: true,
});
